export default __webpack_public_path__ + "static/practicalui-new3-74e1b0e560fb20f2eab59bcf1e20dddd.webp";